import React, { useState, useEffect } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    TextField
} from 'react-admin';
import {
    Grid,
    Box,
} from '@mui/material';
import { CmsEditor } from "./components/Cms/CmsEditor";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const CmsBlockEdit = () => {

    return (
        <Edit redirect={ false }>
            <SimpleForm >
                <TextInput name="name" source="name" />
                <BooleanInput name="enabled" source="enabled" />
                <Box sx={ {
                    display: 'flex',
                    width: '100%',
                    fontSize: '20px',
                    marginBottom: '20px',
                } }>
                    <span>{ "Identifier: " }</span>
                    <TextField source="identifier" sx={ { fontSize: '20px', marginLeft: '30px' } }/>
                </Box>
                <CmsEditor />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
